import React, { createContext, useMemo, useReducer } from 'react';
import { appDataHandlers, appDataInitialState, appDataReducer } from '../reducers/AppDataReducer';

export const AppDataContext = createContext();

const AppDataProvider = (props) => {

  // eventInfoInitialState
  const initState = appDataInitialState()
  const [appData_state, dispatch] = useReducer(appDataReducer, initState);

  const appData_handlers = useMemo(
    () => appDataHandlers(dispatch),
    [dispatch]
  );

  return <AppDataContext.Provider value={{ appData_state, appData_handlers }}>
    {props.children}
  </AppDataContext.Provider>
}

export default AppDataProvider